import { render, staticRenderFns } from "./ComposedHeader.vue?vue&type=template&id=9110a6d2&scoped=true"
import script from "./ComposedHeader.vue?vue&type=script&lang=js"
export * from "./ComposedHeader.vue?vue&type=script&lang=js"
import style0 from "./ComposedHeader.vue?vue&type=style&index=0&id=9110a6d2&prod&scoped=true&lang=scss"
import style1 from "./ComposedHeader.vue?vue&type=style&index=1&id=9110a6d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9110a6d2",
  null
  
)

export default component.exports